import type { BeforeRequestHook } from 'ky'
import { keycloak } from '#shared/lib/auth'

const MIN_VALIDITY_SEC = 10

const authHook: BeforeRequestHook = async (request, options) => {
  if (options.skipAuth) {
    return
  }

  if (!keycloak.authenticated) {
    await keycloak.login({})
  }

  await keycloak.updateToken(MIN_VALIDITY_SEC)

  request.headers.set('Authorization', `Bearer ${keycloak.token}`)
}

export default authHook
